import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { clearMemberToken, clearPreparationAccess } from "@/member/api";
import { useMemberAuth } from "@/member/MemberAuthContext";
import { clearAdminPreview } from "@/adminPreview";
import { exitOperatorMode } from "@/operatorMode";

const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "") + "/api";
const client = axios.create({ baseURL: API, withCredentials: true });

export default function BoardFundraisingPresentationPage() {
  const navigate = useNavigate();
  const { refresh } = useMemberAuth();
  const started = useRef(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    document.title = "Presentation Dashboard | Nonprofit Board Builder";
    clearPreparationAccess(); clearAdminPreview(); exitOperatorMode(); clearMemberToken();
    client.post("/admin/dashboard-preview/presentation/board-fundraising-game").then(async response => {
      await refresh(); navigate(response.data.dashboard_url, { replace: true });
    }).catch(err => setError(err.response?.status === 401 ? "Sign in to your administrator account to open your presentation dashboard." : err.response?.data?.detail || "The presentation dashboard could not be opened."));
  }, [navigate, refresh]);
  return <main className="bf-admin-login"><div className="admin-login-card"><h1>Board Fundraising Presentation</h1>
    <p>{error || "Opening your populated example dashboard…"}</p>
    {error && <Link className="button" to="/admin/board-fundraising">Open administrator login</Link>}
  </div></main>;
}
